var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MATRIX_CELL_WIDTH, MATRIX_SEPARATOR_WIDTH } from '@/constants';
import RenderPrimitive from './RenderPrimitive';
var Shape = /** @class */ (function (_super) {
    __extends(Shape, _super);
    function Shape(_a) {
        var id = _a.id, primitiveType = _a.primitiveType, logicalType = _a.logicalType, primitiveProps = _a.primitiveProps, _b = _a.fillColor, fillColor = _b === void 0 ? 'transparent' : _b, _c = _a.strokeColor, strokeColor = _c === void 0 ? 'none' : _c, _d = _a.shield_definition_id, shield_definition_id = _d === void 0 ? null : _d, _e = _a.shield_id, shield_id = _e === void 0 ? null : _e, _f = _a.printable, printable = _f === void 0 ? false : _f, _g = _a.active_color_mode, active_color_mode = _g === void 0 ? '' : _g, _h = _a.inactive_color_mode, inactive_color_mode = _h === void 0 ? '' : _h;
        var _this = _super.call(this, id, primitiveType, primitiveProps) || this;
        Object.defineProperty(_this, "logicalType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "fillColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "strokeColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "shield_definition_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "shield_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "printable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "active_color_mode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "inactive_color_mode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isMatrix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isMatrixFixedCellWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isMatrixSeparator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isMatrixBordersEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "matrixCellWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "matrixSeparatorWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "matrixRows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "matrices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.fillColor = fillColor;
        _this.strokeColor = strokeColor;
        _this.logicalType = logicalType;
        _this.shield_definition_id = shield_definition_id;
        _this.shield_id = shield_id;
        _this.printable = !!printable;
        _this.active_color_mode = active_color_mode;
        _this.inactive_color_mode = inactive_color_mode;
        _this.isMatrix = false;
        _this.isMatrixFixedCellWidth = false;
        _this.isMatrixSeparator = false;
        _this.isMatrixBordersEnabled = false;
        _this.matrixCellWidth = MATRIX_CELL_WIDTH;
        _this.matrixSeparatorWidth = MATRIX_SEPARATOR_WIDTH;
        _this.matrixRows = [];
        _this.matrices = [];
        return _this;
    }
    Object.defineProperty(Shape, "fromDict", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            // TODO: to implement
            throw 'Method `fromDict` not implemented';
        }
    });
    Object.defineProperty(Shape.prototype, "toDict", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var rawData = __rest(this, []);
            return rawData;
        }
    });
    Object.defineProperty(Shape, "toInitShieldState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return __assign(__assign({}, data), { isMatrix: false, isMatrixFixedCellWidth: false, isMatrixSeparator: false, isMatrixBordersEnabled: false, matrixCellWidth: MATRIX_CELL_WIDTH, matrixSeparatorWidth: MATRIX_SEPARATOR_WIDTH, matrixRows: [], matrices: [] });
        }
    });
    return Shape;
}(RenderPrimitive));
export default Shape;
